import React from 'react';
import { CardConfirm } from '../../components';

const ConfirmTurn = () => (
  <CardConfirm />
);
export default ConfirmTurn;
